import { FormikProps } from "formik";
import moment from "moment/moment";

export const handleChangeCreateDateGte = (data: {
  event;
  child;
  maxPeriod: number;
  formik: FormikProps<any>;
}) => {
  const { event, child, maxPeriod, formik } = data;
  const dateGte = event.target.value;
  const dateLte = formik.values[child.name]?.lte;
  formik.handleChange({
    target: {
      name: `${child.name}.gte`,
      value: dateGte
    }
  });
  if (dateLte) {
    if (
      moment(dateLte).isBefore(moment(dateGte), "d") ||
      moment(dateLte).isAfter(moment(dateGte).add(maxPeriod, "d"))
    ) {
      formik.handleChange({
        target: {
          name: `${child.name}.lte`,
          value: moment(dateGte)
            .add(maxPeriod, "d")
            .format("YYYY-MM-DD")
        }
      });
    }
  }
};

export const handleChangeCreateDateLte = (data: {
  event;
  child;
  maxPeriod: number;
  formik: FormikProps<any>;
}) => {
  const { event, child, maxPeriod, formik } = data;
  const dateLte = event.target.value;
  const dateGte = formik.values[child.name]?.gte;
  formik.handleChange({
    target: {
      name: `${child.name}.lte`,
      value: dateLte
    }
  });
  if (dateGte) {
    if (
      moment(dateGte).isAfter(moment(dateLte), "d") ||
      moment(dateGte).isBefore(moment(dateLte).subtract(maxPeriod, "d"))
    ) {
      formik.handleChange({
        target: {
          name: `${child.name}.gte`,
          value: moment(dateLte)
            .subtract(maxPeriod, "d")
            .format("YYYY-MM-DD")
        }
      });
    }
  }
};
